import axios from 'axios';
import { createContext, useEffect, useState } from 'react';

const LoginContext = createContext();

function LoginProvider({ children }) {

    //state with fields array
    const [login, setLogin] = useState(false);
    const [isLocalhost, setIsLocalhost] = useState(false);
    const [identifier, setIdentifier] = useState(false);

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const param = urlParams.get('app');

        if (param && param.includes('localhost')) {
            const extractedParam = param.replace('-localhost', '');
            setIsLocalhost(true)
            setIdentifier(extractedParam)
        } else if (param && !param.includes('localhost')) {
            setIdentifier(param)
        } else {
            console.log('no match')
        }
    }, []);

    //callback is a fix for useEffect infinite loop
    /*
    const fetchCredentials = useCallback(() => {
        if (localStorage.getItem('token')) {
            setLogin('true')
        }
    }, []);
    */

    const sendCredentials = async (formData) => {

        const appEndpointMap = {
            ikea: '/ikea/ikea_backend/api/user/token/',
            invent: '/sandbox/well_survey_backend/api/user/token/',
            risk: '/sandbox/well_survey_backend/api/user/token/',
            ojaj: '/sandbox/well_survey_backend/api/user/token/'
        };

        const appApiEndpoint = appEndpointMap[identifier];

        await axios.post(`https://digital.bjerking.se${appApiEndpoint}`, formData)
            .then(response => {
                if (isLocalhost) {
                    //window.location.href = `http://localhost:3000/${identifier}?token=${response.data.token}`;
                    window.location.href = `http://localhost:3000/?token=${response.data.token}`;
                } else {
                    //window.location.href = `https://digital.bjerking.se/${identifier}?token=${response.data.token}`;
                    window.location.href = `https://digital.bjerking.se/${identifier}`;
                    localStorage.setItem(`${identifier}-token`, response.data.token);
                }
            })
            .catch(error => {
                setLogin('error')
                localStorage.clear()
            });
    };

    const contextValues = {
        //fetchCredentials,
        login,
        setLogin,
        sendCredentials
    }

    return (
        <LoginContext.Provider value={contextValues}>
            {children}
        </LoginContext.Provider>
    )
}

export { LoginProvider };
export default LoginContext;